module.exports = __webpack_public_path__ + "img/green-dot.14ea66ef.svg";